import React, { useMemo } from "react";

import Table from "../../../../components/tables/Table";
import { formatDateForDisplay } from "../../utils/exportUnitExclusions.helpers";
import { Typography } from "@mui/material";
import styles from "../../../../components/tables/Table.styles";
import { useNavigate } from "react-router-dom";
import { useNavWithTrail } from "../../../../layouts/TrailProvider";



export default function ExportUnitExclusionsTable({ rows = [] }) {

  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const columns = useMemo(() => [
    {
      field: "unit",
      label: "Unit",
      sortable: true,
      type: "number",
      render: (_row, value) => (
        <Typography
          sx={styles.tableLink}
          onClick={() => nav(`/home/units/${encodeURIComponent(value)}`)}
        >
          {value}
        </Typography>
      ),
    },
    {
      label: "Operator",
      field: "operator",
      sortable: true,
    },
    {
      label: "Start Date",
      field: "startDate",
      sortable: true,
      type: "date",
      render: (row) => formatDateForDisplay(row.startDate),
    },
    {
      label: "End Date",
      field: "endDate",
      sortable: true,
      type: "date",
      render: (row) => formatDateForDisplay(row.endDate),
    },
  ], [nav]);

  const defaultSort = { field: "unit", direction: "asc" };

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={columns}
      stickyHeader
      zebra
      bordered
      hover
      getRowId={(row, index) => row.id || String(index)}
      defaultSort={defaultSort}
    />
  );
}
